'use client';
import { CountryData } from '@jucy-ui/common';
import { createFilterOptions } from '@mui/material';

export const countryAutocompleteFilterOptions = createFilterOptions({
    stringify: (option: CountryData) => `${option.name} ${option.code} +${option.phonePrefix}`,
});
